import { store } from '../../../core/Store';
import { Actions } from './reducer';
import * as Selectors from './selectors';

export { Actions, Selectors };

export const openModal = () => {
	store.dispatch(Actions.setModalOpen(true));
};

export const closeModal = () => {
	store.dispatch(Actions.setModalOpen(false));
};
